export default {
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.login': '登录',
  'menu.dashboard': '仪表盘',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.customer-intelligence': '客户情报中心',
  'menu.customer-intelligence.customer-list': '客户列表',
  'menu.customer-intelligence.customer-detail': '客户详情',
  'menu.settings': '系统设置',
  'menu.solution-advancement': '方案推进中心',
  'menu.solution-advancement.detail': '推进详情',
  'menu.field-research': '现场调研',
  'menu.field-research.records': '执行记录',
  'menu.field-research.panel': '执行面板',
  'menu.settings.code-rules': '编码规则',
  'menu.settings.dict': '字典管理',
  'menu.settings.tag-pool': '标签管理',
  'menu.zy-consultant-operations': '问题库',
  'menu.zy-consultant-operations.question-bank': '问题列表',
  'menu.zy-consultant-operations.question-bank.detail': '问题详情',
  'menu.zy-consultant-operations.question-packs': '题包',
  'menu.zy-consultant-operations.question-packs.detail': '题包详情',
  'menu.zy-consultant-operations.diagnosis-sessions': '诊断调查',
  'menu.zy-consultant-operations.diagnosis-sessions.detail': '诊断调查详情',
  'menu.zy-consultant-operations.diagnosis-sessions.run': '执行诊断',
  'menu.zy-consultant-operations.diagnosis-sessions.result': '诊断结果',
  'menu.methodology-center': '方法论沉淀中心',
  'menu.methodology-center.industry-cases': '行业案例库',
  'menu.methodology-center.common-pain-points': '常见痛点库',
  'menu.methodology-center.solution-playbooks': '解决方案库',
  'menu.methodology-center.pilot-scenes': '试点场景库',
  'menu.methodology-center.talk-tracks': '提问话术库',
  'menu.methodology-center.failure-reasons': '失败原因库',
  'menu.methodology-center.success-playbooks': '成功打法库',
  'menu.methodology-center.industry-templates': '行业模板库',
  'menu.methodology-center.analysis-logics': '分析逻辑库',
  'menu.methodology-center.library-detail': '库内详情',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
